module.exports = __webpack_public_path__ + "static/img/qrCode.4a7af06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/appIndex/qrCode.jpg
// module id = 03bn
// module chunks = 32